import { Flex } from '@banhala/ui-kit';
import type { ReactNode } from 'react';
export const ChipBox = ({
  isSelected,
  onPress,
  children,
}: {
  isSelected: boolean;
  onPress: VoidFunction;
  children: ReactNode;
}) => {
  return (
    <Flex.Row
      borderWidth={1}
      borderColor={isSelected ? 'border_black_primary' : 'border_secondary'}
      backgroundColor={isSelected ? 'content_primary' : undefined}
      borderRadius={18}
      padding={{
        horizontal: 12,
        vertical: 10,
      }}
      onPress={onPress}
    >
      {children}
    </Flex.Row>
  );
};
